import { render, staticRenderFns } from "./UpdateCustomerBeneficName.vue?vue&type=template&id=6664af3d&scoped=true"
import script from "./UpdateCustomerBeneficName.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerBeneficName.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerBeneficName.vue?vue&type=style&index=0&id=6664af3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664af3d",
  null
  
)

export default component.exports